/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const ResultsPagination = styled.div`
  margin-top: ${token('space.400', '32px')};
  margin-bottom: ${token('space.500', '40px')};
  display: flex;
  justify-content: center;
`;
